import { Container } from '@mui/material'

import { useEffect, useRef, useState } from 'react'
import { useSelector } from 'react-redux'

import { useLandingZones } from '@features/hooks/LandingZones'
import { useLandingZoneTeams } from '@features/hooks/LandingZones/teams'

import Link from '@components/Link'
import CollapsibleTable from '@components/CollapsibleTable'

import Nodata from '@views/Components/Nodata'
import Membership from '@views/Landingzones/Detail/Components/Membership'

export const Teams = (props) => {
    const lzDataStore = useSelector(state => state.landingZones)
    const dataStore = useSelector(state => state.landingZoneTeams)

    const { load: loadLz } = useLandingZones()
    const { load: loadTeams } = useLandingZoneTeams()

    const [data, setData] = useState([])

    useEffect(() => {
        if (!(lzDataStore.formated.mode > -1)) {
            loadLz(() => { loadTeams(props.id) })
        }
        else loadTeams(props.id)
    }, [])

    useEffect(() => {
        setData(dataStore.formated)
    }, [dataStore.formated])

    const transformName = (params) => {
        if (params.row.link) return (<Link noIcon href={params.row.link} target={'blank'}>{params.value}</Link>)
        else return <span>params.value</span>
    }

    const headers = useRef([
        {field: 'name', headerName: 'Name', isFirst: true, renderCell: transformName},
        {field: 'objectId', headerName: 'Object ID'},
        {field: 'mailNickname', headerName: 'Mail Nickname'}
    ])

    return (
        <Container maxWidth={'xl'} sx={{mt: 2}}>
            {(data && data.length > 0) && (
                <CollapsibleTable
                    headers={headers.current}
                    rows={data}
                    stickyHeader
                    sxGrid={{height: `calc(100vh - (64px + 193px))`}}
                >
                    <Membership />
                </CollapsibleTable>
            )}

            {(data && data.length < 1) && (<Nodata label={'No data to display'} icon={'search_off'} noIcon img />)}
        </Container>
    )
}

export default Teams